import registration from '@/components/popups/registration/index.vue'
import login from '@/components/popups/login/index.vue'
import passwordRecovery from '@/components/popups/password-recovery/index.vue'
import passwordEmail from '@/components/popups/password-email/index.vue'
import registerSuccess from '@/components/popups/register-success/index.vue'
import exit from '@/components/popups/exit/index.vue'
import newPassword from '@/components/popups/new-password/index.vue'
import passwordSuccess from '@/components/popups/password-success/index.vue'
import fastOder from '@/components/popups/fast-order/index.vue'
import thanksOrder from '@/components/popups/order-thanks/index.vue'
import {mapGetters, mapMutations} from 'vuex';
import changePasswordSuccess from '@/components/popups/changePassword/index.vue'
import {CHANGE_POPUP_PASSWORD_EMAIL} from "../../store/mutation-types";


export default {
    name: 'hidden',
    components: {
        registration,
        login,
        passwordRecovery,
        passwordEmail,
        registerSuccess,
        exit,
        newPassword,
        passwordSuccess,
        fastOder,
        thanksOrder,
        changePasswordSuccess
    },
    computed: {
        ...mapGetters({
            showPopUpRegister: `auth/showPopUpRegister`,
            showPopUpLogin: `auth/showPopUpLogin`,
            showPopUpPasswordRecovery: `auth/showPopUpPasswordRecovery`,
            showPopUpPasswordEmail: `auth/showPopUpPasswordEmail`,
            showPopUpRegisterSuccess: `auth/showPopUpRegisterSuccess`,
            showPopUpUserExit: `auth/showPopUpUserExit`,
            showPopUpNewPassword: 'auth/showPopUpNewPassword',
            showPopUpNewPasswordSuccess: 'auth/showPopUpNewPasswordSuccess',
            changeShowFastOrder: 'order/changeShowFastOrder',
            thanksOrder: 'order/changeShowThanksOrder',
            changePassword:'auth/changePasswordPopup'

        })
    },
    methods: {
        ...mapMutations({
            changeShowPopUpRegister: `auth/CHANGE_POPUP_REGISTER`,
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpPasswordRecovery: 'auth/CHANGE_POPUP_PASSWORD_RECOVERY',
            changeShowPopUpPasswordEmail: 'auth/CHANGE_POPUP_PASSWORD_EMAIL',
            changeShowPopUpRegisterSuccess: 'auth/CHANGE_POPUP_REGISTER_SUCCESS',
            changeShowPopUpExit: 'auth/CHANGE_POPUP_USER_EXIT',
            changeShowPopUpNewPassword: 'auth/CHANGE_POPUP_NEW_PASSWORD',
            changeShowPopUpNewPasswordSuccess: 'auth/CHANGE_POPUP_PASSWORD_SUCCESS',
            changeShowPopUpFastOrder: 'order/FAST_ORDER',
            changeShowThanksOrder: 'order/THANKS_ORDER',
            changeShowPopUpPassword: 'auth/SHOW_CHANGE_PASSWORD_POPUP',
        }),
    }
}
